/* eslint-disable */

import request from '@/utils/request'

export function getListAgentApi(query) {
  return request({
    url: '/config-service/v1/agent/list',
    method: 'get',
    params: query
  })
}

export function getListAgentExcelTemplateApi(query) {
  return request({
    url: '/config-service/v1/agent/to-excel/template',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

export function getListAgentToExcelApi(query) {
  return request({
    url: '/config-service/v1/agent/to-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

export function getAgentByIdApi(query) {
  return request({
    url: `/config-service/v1/agent/${query.id}`,
    method: 'get',
    params: query
  })
}

export function addAgentApi(data) {
  return request({
    url: '/config-service/v1/agent/insert',
    method: 'post',
    data
  })
}

export function getMergeProfileApi(data) {
  return request({
    url: '/config-service/v1/agent/get-merge-profile',
    method: 'post',
    data
  })
}

export function insertListAgentExcelApi(data) {
  return request({
    url: '/config-service/v1/agent/excel-insert',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function updateAgentApi(data) {
  return request({
    url: `/config-service/v1/agent/update/${data.id}`,
    method: 'put',
    data
  })
}

export function mergeProfieApi(data) {
  return request({
    url: '/config-service/v1/agent/merge-profile',
    method: 'put',
    data
  })
}

export function deleteAgentApi(data) {
  return request({
    url: '/config-service/v1/agent/delete-ids',
    method: 'delete',
    data
  })
}

export function getAgentSimpleListApi(query) {
  return request({
    url: '/config-service/v1/agent/simple-list',
    method: 'get',
    params: query
  })
}
